<template>
  <div class="px-2 py-[12px] border border-[#E2E2E2] rounded-lg mb-[8px]">
    <div class="flex items-center gap-[8px]">
      <div class="pt-[4px] px-[10px]">
        <span
          class="pin"
          :style="{ '--pin-color': color }"
        />
      </div>
      <h4 class="mb-0 text-sm">
        {{ title }}
      </h4>
      <div>
        <img
          :id="id"
          class="size-[16px] inline-block"
          src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
          alt="info"
        >
        <top-left-popover
          :target="id"
          :content="popoverContent"
        />
      </div>
    </div>
    <div class="flex items-center justify-between flex-wrap gap-10 mt-[30px] mb-[20px]">
      <p class="text-2xl font-semibold text-[#333333] mb-0 ml-[5px]">
        {{ content }}</p>
      <router-link
        :to="link"
        class="border-[1px] text-[12px] border-[#F95031] rounded py-[4px] px-[16px] flex items-center gap-2 hover:shadow"
      >Lihat Detail
        <span class="k-arrow-right-3 text-[18px] font-[600]" />
      </router-link>
    </div>
  </div>
</template>

<script>
import TopLeftPopover from './TopLeftPopover.vue'

/**
 * @component TrenCard
 * @description A card component that displays a trend with a colored pin indicator, title, content, and a detail link.
 * @example
 * <tren-card
 *   id="unique-id"
 *   color="#FF0000"
 *   title="Trend Title"
 *   popover-content="Additional information"
 *   :content="42"
 *   link="/detail-page"
 * />
 */
export default {
  components: {
    TopLeftPopover,
  },
  props: {
    id: {
      required: true,
      type: String,
    },
    color: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    popoverContent: {
      required: true,
      type: String,
    },
    content: {
      required: true,
      type: Number,
    },
    link: {
      required: true,
      type: String,
    },
  },
}
</script>

<style scoped>
.head {
    display: flex;
    align-items: center;
    gap: 8px;
}
.pin, .pin::before, .pin::after {
    display: inline-block;
    border-radius: 100%;
    background-color: var(--pin-color);
}
.pin {
    width: 11px;
    height: 11px;
    position: relative;
}
.pin::before {
    content: '';
    opacity: 30%;
    width: 15px;
    height: 15px;
    position: absolute;
    top: -2px;
    left: -2px;
}
.pin::after {
    content: '';
    opacity: 30%;
    width: 20px;
    height: 20px;
    position: absolute;
    top: -4.5px;
    left: -4.5px;
}
</style>
